module.exports = __webpack_public_path__ + "img/Untitled-2.bcf5fd8a.png";